/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, styled, TextField, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { FundingSource, projectStatus, projectType } from "../../../common/const";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function FilterPanel({
    applyFilter
}) {
    const [expanded, setExpanded] = useState(false);
    const [filters, setFilters] = useState(localStorage.getItem('projectfilters') ? JSON.parse(localStorage.getItem('projectfilters')) : {});

    const handleChange = (panel) => (event, isExpanded) => {
        if (panel === 'panel1' && isExpanded) {
            const obj = filters;
            if (!obj?.types) {
                obj.types = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel2' && isExpanded) {
            const obj = filters;
            if (!obj?.status) {
                obj.status = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel3' && isExpanded) {
            const obj = filters;
            if (!obj?.fundingSource) {
                obj.fundingSource = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel4' && isExpanded) {
            const obj = filters;
            if (!obj?.isDeleted) {
                obj.isDeleted = null;
            }
            setFilters(obj);
        }
        setExpanded(isExpanded ? panel : false);
    };

    const handleFilter = async () => {
        if (filters?.types?.length === 0) {
            showNotification('Please select type', 'error');
        } else if (filters?.status?.length === 0) {
            showNotification('Please select status', 'error');
        } else if (filters?.fundingSource?.length === 0) {
            showNotification('Please select source of funding', 'error');
        } else {
            setExpanded(false);
            await applyFilter(filters);
        }
    }

    return (
        <CustomFilterPanelWrapper>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
            <FilterContent>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.types?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Project Type</Typography>
                            </Box>
                            {expanded === 'panel1' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.types;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={projectType.filter((c) => filters?.types?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={projectType}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    types: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Project Type"
                                    name="Project Type"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.status?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Project Status</Typography>
                            </Box>
                            {expanded === 'panel2' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.status;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={projectStatus.filter((c) => filters?.status?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={projectStatus}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    status: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Project Status"
                                    name="Project Status"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.fundingSource?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Funding Source</Typography>
                            </Box>
                            {expanded === 'panel3' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.fundingSource;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={FundingSource.filter((c) => filters?.fundingSource?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={FundingSource}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    fundingSource: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Funding Source"
                                    name="Funding Source"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.isDeleted === 'yes' || filters?.isDeleted === 'no') && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">InActive Projects</Typography>
                            </Box>
                            {expanded === 'panel4' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.isDeleted;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.isDeleted === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.isDeleted === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </FilterContent>
            <FilterFooter>
                <FixedButton variant="outlined" color="secondary" onClick={() => {
                    applyFilter({});
                    setFilters({});
                    setExpanded(false);
                    localStorage.removeItem('projectfilters');
                }}>Clear</FixedButton>
                <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Apply</FixedButton>
            </FilterFooter>
        </CustomFilterPanelWrapper>
    )
}